import React, { useRef, useEffect } from 'react';
import * as d3 from 'd3';
import * as topojson from 'topojson-client';
import dma from '../../data/google-dma-topojson.json';

// colors
const root = document.documentElement;
const primaryColor = getComputedStyle(root).getPropertyValue('--primary').trim();
const accentColor = getComputedStyle(root).getPropertyValue('--gold').trim();

const DmaSelectorMap = ({ selectedDma, setSelectedDma }) => {
  const mapRef = useRef(null);

  useEffect(() => {
    if (!dma) return;

    const container = mapRef.current;
    const width = container.clientWidth;
    const height = container.clientHeight;

    // Clear previous map render... helps with centering
    d3.select(mapRef.current).selectAll("*").remove();

    const projection = d3
      .geoMercator()
      .fitSize([width, height], topojson.feature(dma, dma.objects.dma_shp));

    const path = d3.geoPath().projection(projection);

    const svg = d3
      .select(mapRef.current)
      .attr('width', width)
      .attr('height', height);

    svg.selectAll('*').remove();

    const g = svg.append('g');

    const nielsen = topojson.feature(dma, dma.objects.dma_shp).features;

    g.selectAll('path')
      .data(nielsen)
      .enter()
      .append('path')
      .attr('d', path)
      .attr('id', (d) =>
        d.properties.dma_name === 'Alaska'
          ? 'national'
          : `dma-${d.properties.dma_name}`
      )
      .attr('fill', primaryColor)
      .attr('stroke', '#333')
      .attr('stroke-width', 0.5)
      .attr('cursor', 'pointer')
      .classed('selectedDMA', (d) => d.properties.dma_name === selectedDma)
      .on('click', (event, d) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'mediaScopeDMAMapSelect',
          dma: d.properties.dma_name
        });
        g.selectAll('path.selectedDMA').classed('selectedDMA', false);
        d3.select(event.target).classed('selectedDMA', true);
        setSelectedDma(d.properties.dma_name);
      })
      .on('mouseover', function () {
        d3.select(this).attr('fill', accentColor);
      })
      .on('mouseout', function () {
        d3.select(this).attr('fill', primaryColor);
      });

    // Add zoom behavior
    const zoom = d3
      .zoom()
      .scaleExtent([0.5, 2])
      .on('zoom', (event) => {
        g.attr('transform', event.transform);
      });

    svg.call(zoom);
  }, []);

  return (
    <div className="dma-selector-map--container">
      <div className="selected-dma">
        { selectedDma ? `Selected DMA: ${selectedDma}` : '' }
      </div>
      <svg ref={mapRef} className="ms-map"></svg>
    </div>
  );
};

export default DmaSelectorMap;
